module.exports = __webpack_public_path__ + "static/media/tums_smorgasberg_jersey_city_22.07d2562e.png";